import {
  camelCase as changeCamelCase,
  snakeCase as changeSnakeCase,
} from "change-case"

export const snakeCase = (value: string) =>
  changeSnakeCase(value, { locale: false })

export const camelCase = (value: string) =>
  changeCamelCase(value, { locale: false })
